
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/v/[url]",
      function () {
        return require("private-next-pages/v/[url].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/v/[url]"])
      });
    }
  